import { GET_USERS_PERMISSIONS } from "../actions/permissions"

const INITAL_STATE = []

export default (state = INITAL_STATE, action) => {
  switch(action.type){
  case GET_USERS_PERMISSIONS:
    return action.payload
  default:
    return state
  }
}